import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import { AuthProvider as AuthContextProvider } from './context/AuthContext';

import Navbar from './components/Navbar/Navbar';
import LinkInterceptor from './components/PageTransition/LinkInterceptor';
import Landing from './components/Landing/Landing';
import FloatingChatbot from './components/Chatbot/FloatingChatbot';
import AnimatedRoutes from './components/PageTransition/AnimatedRoutes';

import { LandingProvider, useLanding } from './context/LandingContext';

function AppContent() {
  const { showLanding, setShowLanding } = useLanding();

  const handleLandingComplete = () => {
    sessionStorage.setItem('hasVisitedLanding', 'true');
    setShowLanding(false);
  };

  return (
    <div style={{ width: '100%', height: '100vh', margin: 0, padding: 0 }}>
      {showLanding && <Landing onComplete={handleLandingComplete} />}
      <Router>
        <AuthContextProvider>
          <LinkInterceptor />
          <Navbar />
          <AnimatedRoutes />
          {!showLanding && <FloatingChatbot />}
        </AuthContextProvider>
      </Router>
    </div>
  );
}

export default function App() {
  return (
    <LandingProvider>
      <AppContent />
    </LandingProvider>
  );
}